<template lang="pug">
nuxt-link.gu24-menu-item(:to="to", :title="name", :class="{ 'gu24-menu-item_active': active}")
  span
    slot {{ name }}
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: false,
      default: '',
    },
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
    to: {
      type: String,
      required: false,
      default: '#',
    },
  },
};
</script>

<style lang="scss" src="./item.scss"></style>
